export const API = process.env.REACT_APP_API_URL;
// export const API = process.env.REACT_APP_API_LOCAL;
export const STARTUPPLAN = process.env.REACT_APP_STARTUP_PLAN;
export const AGENCYPLAN = process.env.REACT_APP_AGENCY_PLAN;
export const STARTUPPLAN2 = process.env.REACT_APP_STARTUP_PLAN2;
export const AGENCYPLAN2 = process.env.REACT_APP_AGENCY_PLAN2;
